import { reserved } from './id'

export const splitNames = (name) => {
  const n = name
    .split(/,\s*/)
    .filter(a => a)
  return n
}

/**
 * Parse raw name inside of curly brackets and return a map.
 * @param {!Array<string>} names An array with named exports, e.g., `['name as alias', 'name2, name3 as alias3']`.
 * @param {function(string): string} [nameFn] The function which adjusts the name.
 */
export const getNamesMap = (names, nameFn) => {
  const n = names
    .reduce((acc, s) => {
      const [nn, a = nn] = s.split(/\s+as\s+/)
      const nt = nn.trim()
      const at = a.trim()
      const pn = nameFn ? nameFn(nt) : nt // private name
      return { ...acc, [at]: pn }
    }, {})
  return n
}

export const checkReserved = (name) => {
  name.replace(reserved, () => {
    throw new Error(`Detected reserved identifier "${name}".`)
  })
}

const simpleGetWs = (segment) => {
  const { length } = segment.split('\n')
  const s = '\n'.repeat(length - 1)
  return s
}

export const getWs = (segment, simple = true) => {
  if (simple) return simpleGetWs(segment)
  const lines = segment.split('\n')
  const s = lines.map(({ length }, i, { length: l }) => {
    // last line
    if (i == l - 1) {
      const ws = ' '.repeat(length)
      return ws
    }
    return ''
  }).join('\n')
  return s
}

// temp solution, until restream markers can store only part of regex, e.g. '%RESTREAM_MARKER%' instead of %RESTREAM_MARKER% for a string.
export const fromRe = /(\s+from\s+)(?:%%_RESTREAM_STRINGS_REPLACEMENT_(\d+)_%%|%%_RESTREAM_LITERALS_REPLACEMENT_(\d+)_%%)/

export const simpleFromRe = /(\s+from\s+(["'`])(.+?)\4)/